import { type ReactNode, useCallback } from "react";

import { useDispatch } from "react-redux";

import { showErrorToast, showSuccessToast } from "app/actions/toast_actions";

export const useToasts = () => {
    const dispatch = useDispatch();

    const handleShowSuccessToast = useCallback(
        (content?: ReactNode) => {
            dispatch(showSuccessToast(content));
        },
        [dispatch],
    );

    const handleShowErrorToast = useCallback(
        (content?: ReactNode, secondaryItems?: ReactNode[]) => {
            dispatch(showErrorToast(content, undefined, undefined, secondaryItems));
        },
        [dispatch],
    );

    return {
        showSuccessToast: handleShowSuccessToast,
        showErrorToast: handleShowErrorToast,
    };
};
